export enum DateFormat {
  DAYS = 'dd HH:mm:ss',
  MINUTES = 'mm:ss',
  DEFAULT = 'hh:mm:ss',
}
